import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { reconciliationApi } from '../services/api-client';
import type { DeadLetterOutboxEvent } from '../types';

export const deadLetterKeys = {
  all: ['admin', 'outbox', 'dead-letter'] as const,
};

export function useDeadLetterOutbox(limit = 50) {
  return useQuery<DeadLetterOutboxEvent[]>({
    queryKey: [...deadLetterKeys.all, limit],
    queryFn: () => reconciliationApi.listDeadLetterOutbox(limit),
  });
}

export function useRequeueOutbox() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => reconciliationApi.requeueOutbox(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deadLetterKeys.all });
    },
  });
}
